import { Box } from '@chakra-ui/react';

export default function Tag({ children }) {
  return (
    <Box as="span" fontSize="xs" px={2.5} py={0.5} borderRadius="md" bg="accentSoft" color="accent" fontWeight="500" lineHeight={1.7}>
      {children}
    </Box>
  );
}
